'use client';

import { useRouter } from 'next/navigation';
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowRight, Video, Bot, Users, Shield } from 'lucide-react';

export default function Page() {
  const router = useRouter();

  const features = [
    {
      icon: <Bot className="h-6 w-6" />,
      title: "AI智能面试官",
      description: "体验与我们的AI面试官进行自然对话，它会根据您的回答进行智能调整"
    },
    {
      icon: <Video className="h-6 w-6" />,
      title: "高质量视频",
      description: "水晶般清晰的视频和音频，确保无缝沟通"
    },
    {
      icon: <Users className="h-6 w-6" />,
      title: "实时协作",
      description: "面试官可以实时观察和参与面试过程"
    },
    {
      icon: <Shield className="h-6 w-6" />,
      title: "安全私密",
      description: "端到端加密确保您的对话保持私密"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white overflow-y-auto -webkit-overflow-scrolling-touch">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h1 className="text-5xl font-bold tracking-tight">
            AI智能视频面试
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            体验未来面试技术，通过AI驱动的视频会议平台。
            自然对话、实时反馈和无缝协作。
          </p>
          <Button 
            size="lg" 
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg"
            onClick={() => router.push('/room')}
          >
            开始面试
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="bg-gray-800 border-gray-700">
              <CardHeader>
                <div className="text-blue-500 mb-4">
                  {feature.icon}
                </div>
                <CardTitle className="text-xl">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-gray-300">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-20">
        <Card className="bg-gray-800 border-gray-700 max-w-4xl mx-auto">
          <CardHeader className="text-center">
            <CardTitle className="text-3xl">准备好改变您的面试体验了吗？</CardTitle>
            <CardDescription className="text-xl text-gray-300">
              加入数千名用户，通过AI革新您的面试流程
            </CardDescription>
          </CardHeader>
          <CardFooter className="flex justify-center">
            <Button 
              size="lg" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg"
              onClick={() => router.push('/room')}
            >
              立即开始
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </CardFooter>
        </Card>
      </div>

      {/* Footer */}
      <footer className="container mx-auto px-4 py-8 text-center text-gray-400 border-t border-gray-800 bg-gray-900/50">
        <p className="text-lg">Powered by HighBar</p>
        <div className="mt-4 space-x-4">
          <a href="https://highbar.co" className="hover:text-white transition-colors text-sm">
            HighBar
          </a>
        </div>
      </footer>
    </div>
  );
}
